var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__close_button",on:{"click":function($event){return _vm.close()}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'times']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }